module.exports = __webpack_public_path__ + "static/TakeshiAndHiroshi4-d7cf8915460f4555c7ea4025d4f5c434.webp";